import { render, staticRenderFns } from "./RegistrationOfInterestPage.vue?vue&type=template&id=4d928d6f&scoped=true&"
import script from "./RegistrationOfInterestPage.vue?vue&type=script&lang=ts&"
export * from "./RegistrationOfInterestPage.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationOfInterestPage.vue?vue&type=style&index=0&id=4d928d6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d928d6f",
  null
  
)

export default component.exports